import { isPdfPasswordProtect } from './helper';

// App-wide upload ceiling; keep every picker and validator aligned to this single value
export const MAX_UPLOAD_FILE_SIZE = 100 * 1024 * 1024;

export const validateFilesForUpload = async ({
  files,
  accept = 'application/pdf',
  maxSize = MAX_UPLOAD_FILE_SIZE
}) => {
  const errorList = [];
  const validFiles = [];

  for (const item of files || []) {
    const isPdfValidation = accept === 'application/pdf';
    const isProtected = isPdfValidation ? await isPdfPasswordProtect(item) : false;

    if (item.size === 0) {
      errorList.push({
        fileName: item?.name,
        fileSize: item.size
      });
      continue;
    }

    if (item.size > maxSize) {
      errorList.push({
        fileName: item?.name,
        fileSize: item.size,
        isFileLarge: true,
        maxSize
      });
      continue;
    }

    if (isPdfValidation && item.type !== 'application/pdf') {
      const fileName = (item?.name || '').toLowerCase();
      const isPdfByName = fileName.endsWith('.pdf');
      if (isPdfByName && !item.type) {
        validFiles.push(item);
        continue;
      }
      errorList.push({
        fileName: item?.name,
        fileTypeError: true
      });
      continue;
    }

    if (isPdfValidation && isProtected) {
      errorList.push({
        fileName: item?.name,
        isPasswordProtected: true
      });
      continue;
    }

    validFiles.push(item);
  }

  return { validFiles, errorList };
};
